// BM-H398 - s10_exclusions. `detected_excluded[]` (person references) with
// `intentional` drives the `exclusion_discuss` hard stop and the IPFDA
// statement companion; `name_excluded_in_will_body` drives
// C-20-exclusion-naming.
//
// BM-H3373 asked a per-person name_in_will_body question once the Will-wide gate was open. BM-H3960 item 36 (the
// solicitor's ruling of 7 Oct 2026) removed that question: nothing reads the answer (C-20-exclusion-naming names every
// detected excluded person), so asking it recorded a choice the Will did not follow. A value already saved is left alone.

import { QuestionRow, SectionIntro, TextArea, YesNo, sectionProps } from "./fields";
import { PeopleList } from "./PersonPicker";

export default function S10Exclusions({ section, setSection, payload, update, person }) {
  const { s, set, nk, setNk } = sectionProps(section, setSection);
  const excluded = s.detected_excluded || [];

  return (
    <div data-testid="section-s10_exclusions">
      <SectionIntro title="People you are leaving out">
        We ask not because we assume you want to leave anyone out, but because the law lets certain family members and dependants ask the court for financial provision from your estate. A clear record of your reasons is evidence the court will take into account.
      </SectionIntro>

      <PeopleList payload={payload} update={update} items={excluded} onChange={(items) => set({ detected_excluded: items })} qid="s10_exclusions.detected_excluded" label="Someone you are deliberately leaving out" testid="s10-excluded" relationshipRequired exclude={[person?.id]} notKnown={nk("detected_excluded")} onNotKnown={(on) => setNk("detected_excluded", on)} />

      {excluded.length > 0 && (
        <div style={{ marginTop: 18 }}>
          <QuestionRow qid="s10_exclusions.intentional" label="Is leaving these people out deliberate?">
            <YesNo testid="s10-intentional" value={s.intentional} onChange={(v) => set({ intentional: v })} yesLabel="Yes, it is deliberate" noLabel="I am not sure, please talk it through with me" />
          </QuestionRow>
          <QuestionRow qid="s10_exclusions.reasons" label="Briefly, your reasons" sensitive>
            <TextArea testid="s10-reasons" value={s.reasons} onChange={(v) => set({ reasons: v })} />
          </QuestionRow>
          <QuestionRow qid="s10_exclusions.name_excluded_in_will_body" label="Should the will itself name any of the people you are leaving out?">
            <YesNo testid="s10-name-in-body" value={s.name_excluded_in_will_body} onChange={(v) => set({ name_excluded_in_will_body: v })} />
          </QuestionRow>
          <QuestionRow qid="s10_exclusions.separate_letter_of_exclusion" label="Would you like to sign a separate letter of exclusion to keep with your will?">
            <YesNo testid="s10-letter" value={s.separate_letter_of_exclusion} onChange={(v) => set({ separate_letter_of_exclusion: v })} />
          </QuestionRow>
        </div>
      )}
    </div>
  );
}
